import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'

import { CustomConfirmDialog } from '../../../../../../components/dialogs'

type Props = {
  isRequestRunning: boolean
  handleDelete: () => Promise<void>
}

export const DeletePackagingTableView: React.FC<Props> = ({
  isRequestRunning,
  handleDelete,
}) => {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState<boolean>(false)

  const handleShow = () => setIsVisible(true)
  const handleHide = () => setIsVisible(false)

  return (
    <>
      <Button
        label={t('deliveryForecastDespatchAdvice.shippingDetails.delete.label')}
        icon="pi pi-trash"
        onClick={handleShow}
        loading={isRequestRunning}
        text
      />

      <CustomConfirmDialog
        severity="danger"
        isVisible={isVisible}
        header={t(
          'deliveryForecastDespatchAdvice.shippingDetails.delete.dialog.title',
        )}
        message={t(
          'deliveryForecastDespatchAdvice.shippingDetails.delete.dialog.message',
        )}
        onHide={handleHide}
        onReject={handleHide}
        onAccept={handleDelete}
        rejectLabel={t(
          'deliveryForecastDespatchAdvice.shippingDetails.delete.dialog.cancel.label',
        )}
        acceptLabel={t(
          'deliveryForecastDespatchAdvice.shippingDetails.delete.dialog.delete.label',
        )}
      />
    </>
  )
}
